const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const isPasswordValid = (password) => {
  if (password.trim().length > 0) {
    return passwordRegex.test(password.trim());
  }
  return true;
};
